import { GoogleMapsModule } from '@angular/google-maps';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MapsComponent } from './components/form-add-address/maps/maps.component';
import { HeaderComponent } from './components';
import { AuthorizationsComponent } from './components/authorizations/authorizations.component';
import { AutocompleteEntityComponent } from './components/autocomplete-entity/autocomplete-entity.component';
import { LocationsComponent } from './components/autocomplete-locations/locations.component';
import { CardListComponent } from './components/card-list/card-list.component';
import { ConfirmComponent } from './components/confirm/confirm.component';
import { DataTableColumnsComponent } from './components/data-table/data-table-columns/data-table-columns.component';
import { DataTableComponent } from './components/data-table/data-table.component';
import { DataTableExternalComponent } from './components/data-table/data-table-external.component';
import { FooterComponent } from './components/footer/footer.component';
import { HighchartsComponent } from './components/highcharts/highcharts.component';
import { ListPrintersComponent } from './components/list-printers/list-printers.component';
import { LoadingComponent } from './components/loading/loading.component';
import { ModalConfirmComponent } from './components/modal-confirm/modal-confirm.component';
import { ModalListComponent } from './components/modal-list/modal-list.component';
import { ModalListCesComponent } from './components/modal-list-ces/modal-list-ces.component';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { ProductCardComponent } from './components/product-card/product-card.component';
import { ProgressbarComponent } from './components/progressbar/progressbar.component';
import { QuantityComponent } from './components/quantity/quantity.component';
import { SnackbarComponent } from './components/snackbar/snackbar.component';
import { CustomerInformationComponent } from './components/customer-information/customer-information.component';
import { FormAddAddressComponent } from './components/form-add-address/form-add-address.component';
import { EditShippingComponent } from './components/sale/edit-shipping/edit-shipping.component';
import { ProgressbarService } from './components/progressbar/progressbar.service';
import { SnackbarService } from './components/snackbar/snackbar.service';
import { AssistantService } from './services/assistant/asssistant.service';
import { AproximationNumberService } from './services/aproximationNumber/aproximationNumber.service';
import { PrintService } from './services/print/print.service';
import { ControlMessagesDirective } from './directives/control-messages.directive';
import { TooltipTitleDirective } from './directives/tooltip-title.directive';
import { NumericDirective, TruncatePipe } from './pipes';
import { FilterListPipe } from './pipes/filter-list.pipe';
import { KeysPipe } from './pipes/keys.pipe';
import { MoneyPipe } from './pipes/money.pipe';
import { ResetMaxMinPipe } from './pipes/reset-max-min.pipe';
import { SortByPipe } from './pipes/order-by.pipe';
import { CalendarComponent } from './components/calendar/calendar.component';
import { CardListFooterComponent } from './components/card-list/card-list-footer/card-list-footer.component';
import { UsefulService } from './services/useful/useful.service';
import { IncrementInputComponent } from './components/increment-input/increment-input.component';
import { WhitespaceDirective, NotWhitespaceDirective, TimeMaskDirective } from './directives';
import { ModalTransactionsComponent } from './components/modal-transactions/modal-transactions.component';
import { TimePickerModule } from './components/time-picker/time-picker.module';
import { ExcelImportModalComponent } from './components/excel-import-modal/excel-import-modal.component';
import { DataImportComponent } from './components/data-import/data-import.component';
import { DispatchDestinationPipe } from './pipes/dispatch-destination.pipe';
import { ParseDatePipe } from './pipes/parse-date.pipe';
import { ConvertToNumberPipe } from './pipes/convert-to-number.pipe';
import { ModalConfirmationListComponent } from './components/modal-confirmation-list/modal-confirmation-list.component';
import { MomentDatePipe } from './pipes/moment-date.pipe';
import { CarouselSlideComponent } from './components/carousel-slide/carousel-slide.component';
import { CarouselSlideItemComponent } from './components/carousel-slide/carousel-slide-item/carousel-slide-item.component';
import { CarouselViewComponent } from './components/carousel-view/carousel-view.component';
import { DispatchTypeCodeComponent } from './components/dispatch-type-code/dispatch-type-code.component';
import { DialogWithIconComponent } from './components/dialog-with-icon/dialog-with-icon.component';
import { DistrictAutocompleteComponent } from './components/district-autocomplete/district-autocomplete.component';
import { PieChartComponent } from './graphs/pie-chart/pie-chart.component';
import { BarChartComponent } from './graphs/bar-chart/bar-chart.component';
import { InputTextSequenceComponent } from './components/input-text-sequence/input-text-sequence.component';
import { MatSelectionListMultipleDirective } from './directives/mat-selection-list-multiple.directive';
import { MultiselectAutocompleteComponent } from './components/multiselect-autocomplete/multiselect-autocomplete.component';
import { EntityAutocompleteComponent } from './components/entity-autocomplete/entity-autocomplete.component';
import { MultiselectWithEntityAutocompleteComponent } from './components/multiselect-with-entity-autocomplete/multiselect-with-entity-autocomplete.component';
import { MultiSelectOfDaysComponent } from './components/multi-select-of-days/multi-select-of-days.component';
import { DispatchZonesComponent } from './components/dispatch-zones/dispatch-zones.component';
import { ModalMissingsComponent } from './components/modal-missings/modal-missings.component';
import { MessageDetailComponent } from './components/modal-missings/message-detail/message-detail.component';
import { MassiveProductCancellationDialogComponent } from './components/massive-product-cancellation-dialog/massive-product-cancellation-dialog.component';
import { MassiveProductReturnDialogComponent } from './components/massive-product-return-dialog/massive-product-return-dialog.component';
import { DataTableWithVirtualScrollComponent } from './components/data-table-with-virtual-scroll/data-table-with-virtual-scroll.component';
import { DispatchTypeAutocompleteComponent } from './components/dispatch-type-autocomplete/dispatch-type-autocomplete.component';
import { GroupNameFilterComponent } from './components/group-name-filter/group-name-filter.component';
import { CurrencySymbolDirective } from './directives/currency-symbol-directive';
import { CarrierAutocompleteComponent } from './components/carrier-autocomplete/carrier-autocomplete.component';
import { PickingOrdersAssignPickerComponent } from './components/picking-orders-assign-picker/picking-orders-assign-picker.component';
import { WebChatSideComponent } from './components/web-chat/side-web-chat/web-chat-side.component';
import { ModalUsersActionComponent } from './components/modal-users-action.component/modal-users-action.component';
import { CalendarRescheduledComponent } from './components/calendar/calendar-rescheduled.component';
import { MaterialModule } from '../material.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { CaptchaComponent } from './components/captcha/captcha.component';
import { CustomDateAdapter } from './adapters/custom-date-adapter';
import { DateAdapter } from '@angular/material/core';
import { NewMapComponent } from './components/new-map-form.component/new-map.component/new-map.component';
import { NewMapFormComponent } from './components/new-map-form.component/new-map-form.component';
import { MapPositionComponent } from './components/new-map-form.component/map-position.component/map-position.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MaterialModule,
    GoogleMapsModule,
    TimePickerModule,
    MatDialogModule,
    MatIconModule,
  ],
  providers: [
    AssistantService,
    PrintService,
    AproximationNumberService,
    SnackbarService,
    ProgressbarService,
    UsefulService,
    {
      provide: DateAdapter,
      useClass: CustomDateAdapter,
    },
  ],
  declarations: [
    CalendarRescheduledComponent,
    HeaderComponent,
    SnackbarComponent,
    ProgressbarComponent,
    LoadingComponent,
    ConfirmComponent,
    QuantityComponent,
    TooltipTitleDirective,
    KeysPipe,
    ModalListComponent,
    ModalListCesComponent,
    LocationsComponent,
    AutocompleteEntityComponent,
    MoneyPipe,
    FilterListPipe,
    DataTableComponent,
    DataTableExternalComponent,
    ModalConfirmComponent,
    ResetMaxMinPipe,
    CardListComponent,
    CardListFooterComponent,
    ProductCardComponent,
    FooterComponent,
    DataTableColumnsComponent,
    HighchartsComponent,
    MapsComponent,
    PaginatorComponent,
    MatSelectionListMultipleDirective,
    ControlMessagesDirective,
    TruncatePipe,
    NumericDirective,
    AuthorizationsComponent,
    ListPrintersComponent,
    CustomerInformationComponent,
    FormAddAddressComponent,
    CalendarComponent,
    EditShippingComponent,
    WhitespaceDirective,
    NotWhitespaceDirective,
    TimeMaskDirective,
    IncrementInputComponent,
    ModalTransactionsComponent,
    ExcelImportModalComponent,
    DataImportComponent,
    DispatchDestinationPipe,
    ParseDatePipe,
    ConvertToNumberPipe,
    MomentDatePipe,
    ModalConfirmationListComponent,
    CarouselSlideComponent,
    CarouselSlideItemComponent,
    CarouselViewComponent,
    DispatchTypeCodeComponent,
    InputTextSequenceComponent,
    PieChartComponent,
    BarChartComponent,
    DialogWithIconComponent,
    DistrictAutocompleteComponent,
    MultiselectAutocompleteComponent,
    SortByPipe,
    EntityAutocompleteComponent,
    MassiveProductCancellationDialogComponent,
    MultiselectWithEntityAutocompleteComponent,
    MultiSelectOfDaysComponent,
    DispatchZonesComponent,
    ModalMissingsComponent,
    MessageDetailComponent,
    MassiveProductReturnDialogComponent,
    DataTableWithVirtualScrollComponent,
    DispatchTypeAutocompleteComponent,
    GroupNameFilterComponent,
    CurrencySymbolDirective,
    CarrierAutocompleteComponent,
    PickingOrdersAssignPickerComponent,
    WebChatSideComponent,
    ModalUsersActionComponent,
    CaptchaComponent,
    NewMapComponent,
    NewMapFormComponent,
    MapPositionComponent,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    // HttpClientModule, DEPRECATED, AHORA SE IMPORTA provideHttpClient(withInterceptorsFromDi()), VALIDAR QUE SIGA FUNCIONANDO Y LUEGO ELIMINAR LINEA
    RouterModule,
    MaterialModule,
    HeaderComponent,
    SnackbarComponent,
    ProgressbarComponent,
    LoadingComponent,
    QuantityComponent,
    TooltipTitleDirective,
    KeysPipe,
    MoneyPipe,
    FilterListPipe,
    ModalListComponent,
    ModalListCesComponent,
    LocationsComponent,
    AutocompleteEntityComponent,
    DataTableComponent,
    DataTableExternalComponent,
    ResetMaxMinPipe,
    CardListComponent,
    CardListFooterComponent,
    ProductCardComponent,
    ModalConfirmComponent,
    FooterComponent,
    DataTableColumnsComponent,
    HighchartsComponent,
    MapsComponent,
    PaginatorComponent,
    MatSelectionListMultipleDirective,
    ControlMessagesDirective,
    TruncatePipe,
    NumericDirective,
    AuthorizationsComponent,
    ListPrintersComponent,
    CustomerInformationComponent,
    FormAddAddressComponent,
    CalendarComponent,
    EditShippingComponent,
    WhitespaceDirective,
    NotWhitespaceDirective,
    TimeMaskDirective,
    IncrementInputComponent,
    ModalTransactionsComponent,
    TimePickerModule,
    ExcelImportModalComponent,
    DataImportComponent,
    DispatchDestinationPipe,
    ParseDatePipe,
    ConvertToNumberPipe,
    MomentDatePipe,
    ModalConfirmationListComponent,
    CarouselSlideComponent,
    CarouselSlideItemComponent,
    CarouselViewComponent,
    DispatchTypeCodeComponent,
    InputTextSequenceComponent,
    PieChartComponent,
    BarChartComponent,
    DialogWithIconComponent,
    MultiselectAutocompleteComponent,
    DistrictAutocompleteComponent,
    SortByPipe,
    EntityAutocompleteComponent,
    MultiselectWithEntityAutocompleteComponent,
    MultiSelectOfDaysComponent,
    DispatchZonesComponent,
    ModalMissingsComponent,
    MessageDetailComponent,
    MassiveProductCancellationDialogComponent,
    MassiveProductReturnDialogComponent,
    DataTableWithVirtualScrollComponent,
    DispatchTypeAutocompleteComponent,
    GroupNameFilterComponent,
    CurrencySymbolDirective,
    CarrierAutocompleteComponent,
    WebChatSideComponent,
    ModalUsersActionComponent,
    CalendarRescheduledComponent,
    PickingOrdersAssignPickerComponent,
    CaptchaComponent,
    NewMapFormComponent,
  ],
})
export class SharedModule {}
